import { render, staticRenderFns } from "./ModalControlGroup.vue?vue&type=template&id=c2d486d0&scoped=true"
import script from "./ModalControlGroup.vue?vue&type=script&lang=js"
export * from "./ModalControlGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalControlGroup.vue?vue&type=style&index=0&id=c2d486d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d486d0",
  null
  
)

export default component.exports